import { render, staticRenderFns } from "./ClubProfile.vue?vue&type=template&id=384b31c0&scoped=true&"
import script from "./ClubProfile.vue?vue&type=script&lang=js&"
export * from "./ClubProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384b31c0",
  null
  
)

export default component.exports